import { Box, Container, styled } from '@mui/material'
import { Route, Routes } from 'react-router-dom'

import { WebPayment } from '../pages'
import PaymentRedirectReceiver from '../pages/webPayment/paymentRedirectReceiver'
import { MoovyPalette } from '../styles/theme'
import MoovyRoute from './moovyRoute'

const Main = styled('main')({
  backgroundColor: MoovyPalette.colorMainBackground,
  minHeight: '100vh',
  maxHeight: '-webkit-fill-available',
})

const MoovyRouters = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <MoovyRoute>
            <Box
              sx={{
                position: 'relative',
              }}
            >
              <Main>
                <Container
                  style={{
                    paddingTop: 10,
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingBottom: 20,
                    maxWidth: '800px',
                  }}
                >
                  <WebPayment />
                </Container>
              </Main>
            </Box>
          </MoovyRoute>
        }
      />
      <Route
        path="/success"
        element={<PaymentRedirectReceiver type="success" />}
      />
      <Route
        path="/cancel"
        element={<PaymentRedirectReceiver type="cancel" />}
      />
    </Routes>
  )
}

export default MoovyRouters
